import './_controller-title.scss';
import {useState} from "react";

const ControllerTitle = () => {
    const [image, setImage] = useState('./assets/images/blank_logo.svg');

    function handleFileChange(e: any) {
        const file = e.target.files[0];
        if (!file) return;
        const imageSrc = URL.createObjectURL(e.target.files[0]);
        setImage(imageSrc);
    }

    return <div className='controller-title'>
        <div className='logo-container'>
            <img src={image} alt="Icon"/>
            <input type="file" accept="image/*,.svg,.svg+xml" onInput={handleFileChange}/>
        </div>
        <div className='d-flex flex-column'>
            {/*<h3>Walcott Glenn</h3>
            <h6>19174 62nd Avenue, Corcoran <br/> Minnesota 55340</h6>*/}
            <h3>Title</h3>
            <h6>Address</h6>
        </div>
    </div>
}

export default ControllerTitle;
